import { render } from "./MsrpExplain.vue?vue&type=template&id=1ffa631e&scoped=true"
import script from "./MsrpExplain.vue?vue&type=script&lang=js"
export * from "./MsrpExplain.vue?vue&type=script&lang=js"

import "./MsrpExplain.vue?vue&type=style&index=0&id=1ffa631e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffa631e"]])

export default __exports__